import { useTranslation } from 'react-i18next'
import { ButtonNextLink } from '@/components/ButtonNextLink'
import { useProductMetadata } from '@/components/LayoutWithMenu/productMetadataHooks'
import { isSameLink } from '@/utils/url'

type Props = {
  url: string
}

export const ProductGridItemBlockProductCTA = ({ url }: Props) => {
  const { t } = useTranslation('common')

  const products = useProductMetadata()
  const product = products?.find((product) => isSameLink(product.pageLink, url))
  if (product == null) {
    console.warn(`Did not find product for link ${url}, skipping CTA render!`)
    return
  }

  return (
    <ButtonNextLink href={{ pathname: product.priceCalculatorPageLink }} size="medium" variant="primary-alt">
      {t('GET_PRICE_LINK')}
    </ButtonNextLink>
  )
}
